import { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import Api from '../../../Auth/Api';
import AddUsuarioModal from '../Modals/AddUsuarioModal';

const UsuariosManager = ({ token, nivel }) => {
    const [showModalAddUsuario, setShowModalAddUsuario] = useState(false);
    const [loadingSaveUser, setLoadingSaveUser] = useState(false);
    const [selectCursos, setSelectCursos] = useState(false);
    
    // Estados para dados
    const [dataCargos, setDataCargos] = useState([]);
    const [dataGestores, setDataGestores] = useState([]);
    const [dataUnidades, setDataUnidades] = useState([]);
    const [dataEmpresas, setDataEmpresas] = useState([]);

    const {
        register,
        handleSubmit,
        control,
        reset,
        setValue,
        formState: { errors },
    } = useForm();

    // Carregar cargos
    useEffect(() => {
        async function fetchCargos() {
            try {
                const response = await Api.get(`api/show/cargos`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataCargos(response.data.map((cargo) => ({
                    value: cargo.id,
                    label: cargo.nome
                })));
            } catch (error) {
                console.error("Erro ao carregar cargos:", error);
            }
        }
        fetchCargos();
    }, [token]);

    // Carregar gestores (apenas para Admin e Moderador)
    useEffect(() => {
        async function fetchGestores() {
            if (nivel === 'Gestor') return; // Gestores não precisam carregar lista de gestores
            
            try {
                const response = await Api.get(`api/show/gestores`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataGestores(response.data.map((cargo) => ({
                    value: cargo.id,
                    label: cargo.nome_completo
                })));
            } catch (error) {
                console.error("Erro ao carregar gestores:", error);
            }
        }
        fetchGestores();
    }, [token, nivel]);

    // Carregar unidades
    useEffect(() => {
        async function fetchUnidades() {
            try {
                const response = await Api.get(`api/show/unidades`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataUnidades(response.data.map((unidade) => ({
                    value: unidade.id,
                    label: unidade.nome
                })));
            } catch (error) {
                console.error("Erro ao carregar unidades:", error);
            }
        }
        fetchUnidades();
    }, [token]);

    // Carregar empresas (apenas para Admin e Moderador)
    useEffect(() => {
        async function fetchEmpresas() {
            if (nivel === 'Gestor') return; // Gestores não precisam carregar lista de empresas
            
            try {
                const response = await Api.get(`api/listar-empresas`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataEmpresas(response.data.map((empresa) => ({
                    value: empresa.id,
                    label: empresa.titulo
                })));
            } catch (error) {
                console.error("Erro ao carregar empresas:", error);
            }
        }
        fetchEmpresas();
    }, [token, nivel]);

    const onSubmitAddUsuario = async (data) => {
        setLoadingSaveUser(true);
        
        // Formatar os cursos selecionados, se houver
        if (data.cursos && Array.isArray(data.cursos)) {
            data.cursos = data.cursos.map(curso => curso.value);
        }

        try {
            const response = await Api.post("/api/novo-usuario", data, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            
            // Limpar formulário e fechar modal
            reset();
            setValue("nivel", "");
            setValue("codigo", "");
            
            return {
                success: true,
                message: response.data.message || "Usuário cadastrado com sucesso!"
            };
        } catch (error) {
            console.error("Erro ao criar novo usuário:", error);
            
            return {
                success: false,
                message: error.response?.data?.message || "Erro ao criar usuário"
            };
        } finally {
            setLoadingSaveUser(false);
        }
    };

    const openAddUsuarioModal = () => {
        setShowModalAddUsuario(true);
        reset();
    };

    // Estilos para os campos Select
    const customStyles = {
        control: (base, state) => ({
            ...base,
            fontSize: "1rem",
            backgroundColor: "#ffffff",
            borderRadius: "0.25rem",
            boxShadow: state.isFocused ? "0 0 0 0.25rem #27485b73" : null,
            borderColor: "#233734",
            "&:hover": {
                borderColor: "#3a6883"
            },
        }),
        singleValue: (base) => ({
            ...base,
            color: '#000',
        }),
        input: (base) => ({
            ...base,
            color: '#adb5bd',
            height: "52px",
            margin: '0px',
            padding: '0px !important',
        }),
        menu: (base) => ({
            ...base,
            backgroundColor: '#fff',
        }),
        option: (base, state) => ({
            ...base,
            color: state.isSelected ? '#3a5a6c' : null,
            backgroundColor: state.isFocused ? '#27485b73' : null,
            "&:active": {
                backgroundColor: "#27485b73"
            },
        }),
    };

    return {
        openAddUsuarioModal,
        showModalAddUsuario,
        setShowModalAddUsuario,
        loadingSaveUser,
        onSubmitAddUsuario,
        renderModal: (dataCursos) => (
            <AddUsuarioModal
                showModalAddUsuario={showModalAddUsuario}
                setShowModalAddUsuario={setShowModalAddUsuario}
                dataCargos={dataCargos}
                dataUnidades={dataUnidades}
                dataGestores={dataGestores}
                dataEmpresas={dataEmpresas}
                dataCursos={dataCursos}
                customStyles={customStyles}
                nivel={nivel}
                register={register}
                control={control}
                errors={errors}
                handleSubmit={handleSubmit}
                onSubmitAddParticipante={onSubmitAddUsuario}
                loadingSaveUser={loadingSaveUser}
                selectCursos={selectCursos}
                setSelectCursos={setSelectCursos}
            />
        )
    };
};

export default UsuariosManager; 